// Portada de "Alba" (bautismo): paloma con rama de olivo (SVG original),
// nombre en caligrafía y fotografía en arco bautismal. En escritorio la
// composición se divide: texto a la izquierda, arco a la derecha.
import { motion, useReducedMotion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { FondoVideoAmbient } from "../../shared";

// Paloma con rama de olivo — ilustración SVG original de esta plantilla.
export function Paloma({ className = "" }) {
  return (
    <svg
      className={`bt-paloma ${className}`}
      viewBox="0 0 120 90"
      fill="none"
      aria-hidden="true"
      data-testid="bt-paloma"
    >
      {/* cuerpo y alas */}
      <path
        d="M18 58c10-16 30-24 46-20l14-14c2-2 5-2 6 1l3 9 10-6c2-1 5 0 5 3 0 12-8 24-20 30l-4 14c-1 3-5 3-6 0l-6-12c-16 4-34 0-46-9-2-1-3-3-2-4 1-1 2 0 0 8z"
        fill="currentColor"
        opacity="0.92"
      />
      {/* ala superior */}
      <path
        d="M46 40c-2-12 4-24 14-30 2-1 4 0 4 2l2 14c0 8-4 14-10 17l-8 3c-1 0-2-2-2-6z"
        fill="currentColor"
        opacity="0.55"
      />
      {/* ojo */}
      <circle cx="88" cy="26" r="2.2" fill="var(--bt-fondo)" />
      {/* rama de olivo */}
      <path
        d="M96 40c8 2 14 8 16 16"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
      />
      <path d="M104 44c3-2 7-2 9 1-3 2-7 2-9-1z" fill="currentColor" />
      <path d="M108 50c3-2 7-2 9 1-3 2-7 2-9-1z" fill="currentColor" />
      <path d="M101 48c-1 3-4 5-7 4 1-3 4-5 7-4z" fill="currentColor" />
    </svg>
  );
}

export default function Portada({ datos }) {
  const { protagonista, evento, fotos } = datos;
  const reduce = useReducedMotion();
  const entrar = (delay) => ({
    initial: { opacity: 0, y: reduce ? 0 : 18 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] },
  });

  return (
    <header className="bt-portada" data-testid="bt-portada">
      <div className="bt-portada-texto">
        <motion.div {...entrar(0.05)}>
          <Paloma />
        </motion.div>
        <motion.p className="bt-portada-frase" {...entrar(0.15)}>
          {protagonista.fraseIntroductoria}
        </motion.p>
        <motion.h1
          className="bt-portada-nombre"
          data-testid="bt-nombre-protagonista"
          {...entrar(0.3)}
        >
          {protagonista.nombre}
        </motion.h1>
        <motion.p className="bt-portada-fecha" data-testid="bt-fecha" {...entrar(0.45)}>
          {evento.fechaLegible}
          <span className="bt-portada-ciudad">{evento.ciudad}</span>
        </motion.p>
        <motion.p className="bt-portada-mensaje" {...entrar(0.6)}>
          {protagonista.mensajePortada}
        </motion.p>
        <motion.a
          href="#bt-contenido"
          className="bt-portada-bajar"
          aria-label="Desplazarse al contenido de la invitación"
          data-testid="bt-boton-bajar"
          {...entrar(0.75)}
        >
          <span>{protagonista.textoBotonEntrada || "Ver la invitación"}</span>
          <ArrowDown size={15} strokeWidth={1.5} />
        </motion.a>
      </div>
      <motion.div className="bt-portada-arco" {...entrar(0.5)}>
        {datos.portadaVideo?.urlYoutube ? (
          <FondoVideoAmbient
            urlYoutube={datos.portadaVideo.urlYoutube}
            poster={datos.portadaVideo.poster || fotos.portada}
          />
        ) : (
          <img
            className="bt-portada-foto"
            src={fotos.portada}
            alt={`Fotografía de ${protagonista.nombre}`}
          />
        )}
      </motion.div>
    </header>
  );
}
